import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles(({ spacing, palette }: any) => ({
  headerContainer: {
    background: palette.primary.main,
    padding: `${spacing(2)}px 0px`,
    color: palette.text.contrastText,
  },
  billContentContainer: {
    boxShadow: `0px 1px 3px ${palette.background.contrastShadow}`,
    borderRadius: '1px',
    position: 'relative',
    marginBottom: spacing(5),
  },
}));

interface BillBodyProps {
  title?: string;
}

const BillBody: FC<BillBodyProps> = ({ title, children }) => {
  const classes = styles();

  return (
    <Grid container justifyContent="center">
      {title && (
        <Grid container justifyContent="center" className={classes.headerContainer}>
          <Typography variant="h1" color="inherit">
            {title}
          </Typography>
        </Grid>
      )}
      <Grid container justifyContent="center" className={classes.billContentContainer}>
        {children}
      </Grid>
    </Grid>
  );
};

export default BillBody;
